import { render, staticRenderFns } from "./SolicitorCustomerCaseDetailsTab.vue?vue&type=template&id=47db10b0"
import script from "./SolicitorCustomerCaseDetailsTab.vue?vue&type=script&lang=js"
export * from "./SolicitorCustomerCaseDetailsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports